export default __webpack_public_path__ + "static/media/Services5.57de222b.jpg";